import { useViewedEmployee } from './useViewedEmployee';

import { useGetReceivedRecognitions } from '@/api/employee-portal';
import { useGetMyEvolution } from '@/api/performance-profile';

/**
 * The portal's two employee-scoped reads, each already pointed at whoever's portal is open. Every
 * section reads through these rather than through the API hooks directly, so the employee is read
 * from the address once per section and no section can end up drawing someone else's data.
 */

/** The competency journey behind the summary tab's sections. */
export const usePortalEvolution = () => useGetMyEvolution(useViewedEmployee().viewedEmployeeId);

/** The recognitions behind the summary tab's last section. */
export const usePortalRecognitions = () =>
    useGetReceivedRecognitions(useViewedEmployee().viewedEmployeeId);
